import React, { useEffect, useState } from 'react';
import { Button, useDisclosure } from '@nextui-org/react';
import UpcomingCard from '../UpcomingCard/UpcomingCard';
import { Col, Row, Spin, message } from 'antd';
import NoticePanel from '../NoticePanel/NoticePanel';
import SessionSection from '../SessionSection/SessionSection';
import SessionSectionInComplete from '../SessionSection/SessionSectionInComplete';
import MarketPredictionCard from '../MarketPredictionCard/MarketPredictionCard';
import { decryptData } from '../../utils/encryptData';
import { useDispatch, useSelector } from 'react-redux';
import { getAllSessions } from '../../redux/features/sessions/sessionActions';
import { Link, useNavigate } from 'react-router-dom';
import ErrorBoundary from '../../utils/Errorboundary';

function UpcomingSection() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, data } = useSelector((state) => state.session);

  const { uid, rl } = useSelector((state) => state.auth);
  const role = decryptData(rl);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(getAllSessions())
        .unwrap()
        .catch((err) =>
          message.error(err.error || 'Failed to fetch sessions data')
        );
    };
    fetchData();
  }, [dispatch]);

  const filteredData = data?.events
    ?.filter(
      (session) =>
        session?.event_status === 'upcoming' && session?.status === 'active'
    )
    .sort((a, b) => {
      const eventIdA = parseInt(a.eventId.replace('F_EID_', ''), 10);
      const eventIdB = parseInt(b.eventId.replace('F_EID_', ''), 10);
      return eventIdB - eventIdA;
    })
    .slice(0, 3); // Get top 3 results after sorting

  const navigateToSession = (id) => {
    if (!id) {
      message.error('Session ID not found');
    }
    navigate('/session/all');
  };

  console.log('#ok');

  return (
    <>
      <Row className="justify-start mr-3 ml-[-35px] lg:ml-[0px]">
        <Spin spinning={loading} fullscreen />

        {/* upcoming section */}
        <Col className="mb-3" span={24} md={15} lg={18}>
          {' '}
          {/* 6/8 of the row */}
          {filteredData?.length > 0 && (
            <h5 className="mt-6 ml-9 md:ml-5 mb-4 text-white font-poppins text-xl md:text-2xl font-bold">
              Upcoming Sessions
            </h5>
          )}
          {/* {filteredData?.length === 0 && <h1 className='text-white ml-8 text-xl font-normal'>No Sessions Found</h1>} */}
          {filteredData?.length != 0 ? (
            <>
              {filteredData?.map((session, index) => (
                <ErrorBoundary>
                  <UpcomingCard
                    key={index}
                    id={session?.eventId}
                    imageSrc={session?.coverImage[0]?.url}
                    altText={session?.coverImage[0]?.imageName}
                    title={session?.event_name}
                    presenter={session?.presenter}
                    description={session?.description}
                    language={session?.medium}
                    category={session?.category}
                    date={session?.date}
                    startTime={session?.startTime}
                    endTime={session?.endTime}
                    url={session?.zoomLink}
                  />
                </ErrorBoundary>
              ))}
            </>
          ) : (
            <ErrorBoundary>
              <SessionSectionInComplete />
            </ErrorBoundary>
          )}
        </Col>

        <Col
          className="mb-[-13px] md:mr-[-200px] w-full   sm:block"
          md={9}
          lg={6}
        >
          <div>
            <>
              <h2 className=" mt-6 ml-10 mb-4 text-white font-poppins text-xl font-bold">
                Today Market Prediction
              </h2>
              <ErrorBoundary>
                <MarketPredictionCard />
              </ErrorBoundary>
            </>

            <h2 className=" mt-6 ml-10 mb-4 text-white font-poppins text-xl font-bold hidden md:block">
              Latest Market Analysis
            </h2>
            <ErrorBoundary>
              <NoticePanel />
            </ErrorBoundary>
          </div>
        </Col>
      </Row>

      {/* view all btn */}
      <div className="flex justify-center mt-1 mb-10">
        {filteredData?.length !== 0 && (
          <Button
            size="sm"
            onPress={navigateToSession}
            className="border-btn-color font-poppins text-white text-sm"
            variant="bordered"
          >
            View all
          </Button>
        )}
      </div>
    </>
  );
}

export default UpcomingSection;
